import {TypeConstant} from "./TypeConstant";

const initStat = {
    linkedin :'',
    twitter:'',
    facebook:'',
    github:''
}

const socialReducer = (state = initStat , action) => {
    switch (action.type) {
        case TypeConstant.Linkedin: return {...state, linkedin : action.payload}
        case TypeConstant.Twitter: return {...state, twitter:action.payload}
        case TypeConstant.Facebook: return {...state, facebook:action.payload}
        case TypeConstant.Github: return {...state, github :action.payload}

        default: return state;
    }
}

export default socialReducer;
